import { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  UserOutlined,
  EuroCircleOutlined,
  InfoCircleOutlined,
  LeftOutlined,
} from '@ant-design/icons'
import { Menu } from 'antd'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { FirebaseApp } from 'firebase/app'

import Payments from './payments'
import UserData from './userdata'
import About from './about'
import Promocodes from './promocode'

type Props = {
  firebaseApp: FirebaseApp
  setDashMenu: (value?: string) => void
  setUserHasBilling: (value?: boolean) => void
}

const stripePromise = loadStripe('pk_live_yhBtan5dat0NlWyRn4tmMT9z005tCEQoFb')

const Profile = ({ firebaseApp, setDashMenu, setUserHasBilling }: Props) => {
  const [activeMenu, setActiveMenu] = useState<string>('1')
  const [clientSecret, setClientSecret] = useState<any>(undefined)

  const clientSecretCall = async () => {
    const response = await fetch('https://loja.piroestrela.pt/api/intent.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({
        paymentMethodType: 'card',
        currency: 'eur',
      }),
    }).then((response) => response.json())

    setClientSecret(response.client_secret)
  }

  useEffect(() => {
    if (!clientSecret) {
      clientSecretCall()
    }
  }, [clientSecret])

  const rightPanelContent = () => {
    if (activeMenu === '1') {
      return <UserData firebaseApp={firebaseApp} />
    }

    if (activeMenu === '2') {
      return (
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret,
            locale: 'pt',
          }}
        >
          <Payments
            firebaseApp={firebaseApp}
            setUserHasBilling={setUserHasBilling}
          />
        </Elements>
      )
    }

    if (activeMenu === '3') {
      return <About />
    }

    if (activeMenu === '4') {
      return (
        <Promocodes
          firebaseApp={firebaseApp}
          changeNavigation={onMenuClick}
          setUserHasBilling={setUserHasBilling}
        />
      )
    }

    return null
  }

  const onMenuClick = ({ key }: any) => {
    if (key === '0') {
      setDashMenu(undefined)
      return
    }

    setActiveMenu(key)
  }

  return (
    <Container>
      <Menu
        style={{ width: 256, height: '100%' }}
        defaultSelectedKeys={[activeMenu]}
        onClick={onMenuClick}
      >
        <Menu.Item key="0" icon={<LeftOutlined />}>
          Voltar
        </Menu.Item>
        <Menu.Item key="1" icon={<UserOutlined />}>
          Conta
        </Menu.Item>
        <Menu.Item key="2" icon={<EuroCircleOutlined />}>
          Subscrição
        </Menu.Item>
        <Menu.Item key="4" icon={<EuroCircleOutlined />}>
          Promocodes
        </Menu.Item>
        <Menu.Item key="3" icon={<InfoCircleOutlined />}>
          Sobre
        </Menu.Item>
      </Menu>
      <RightPanel>{rightPanelContent()}</RightPanel>
    </Container>
  )
}

export default Profile

const Container = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 100px);
  max-height: calc(100% - 100px);
`

const RightPanel = styled.div`
  width: 100%;
  height: 100%;
`
